import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import ErrorIcon from '@src/assets/images/referral-error-noti.svg';

const VoiceProcessingError = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Box
        sx={{ display: 'flex', justifyContent: 'center', paddingTop: '64px' }}
      >
        <img src={ErrorIcon} alt="icon" className="icon" width={80} />
      </Box>
      <Typography variant="subtitle1" mt={2} align="center">
        {t('voiceProcessingError')}
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={6} align="center">
        {t('pleaseTryAgainOrCreateNewVoice')}
      </Typography>
    </Box>
  );
};

export default VoiceProcessingError;
